import { PersonalDataSectionsState } from '../../../+grid-application-shared/entities/sections-state/personalDataSectionsState';
import { Address } from './address';

export class AddressAndPersonalData extends Address {
  constructor(application_id: number) {
    super(application_id);
  }

  id: number;
  sk_title: string;
  country: string;
  company_name: string | null;
  firstname: string;
  lastname: string;
  phone: string;
  mobile: string | null;
  email: string;
  repeat_email: string; // <- UI helper property
  personal_data_sections_state: PersonalDataSectionsState;
  recipient_id?: number;
}
